<!--
 * @LastEditors: taoyan taoyan_work@163.com
-->
<template>
  <div class="feed-box">
    <div class="back" @click="goBack">
      <div class="arrow-left"></div>
      <!-- <van-icon name="arrow-left" /> -->
    </div>
    <div class="list">
      <div>
        <div>喂养日期</div>
        <div v-if="$route.query.id">
          <span>{{ formatDate(feedData.currentDateTemp) }}</span>
        </div>
        <div v-else @click="isDatePopup">
          <span>{{ formatDate(feedData.currentDateTemp) }}</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <div>
        <div>喂养时间</div>
        <div @click="isHourPopup">
          <span>{{ feedData.currentTimeTemp }}</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <div>
        <div>喂养方式</div>
        <div @click="feedPopup = true">
          <span>{{ feedValue }}</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <div v-show="feedValue == '母乳亲喂'">
        <div>喂养量（ml）</div>
        <div>
          <input
            class="list-input"
            type="tel"
            v-model="breastWeight"
            v-on:input="changeInput($event)"
          />
        </div>
      </div>
      <div v-show="feedValue == '辅食'">
        <div>喂养量（g）</div>
        <div @click="feedWeightPopup = true">
          <span>{{ fushiWeight }}</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <div v-show="feedValue == '辅食'">
        <div>辅食</div>
        <div class="list-r">
          <p v-if="feedData.fushi.length == 0">点击选择下列标签，最多可添加3个</p>
          <div
            v-for="(item, index) in feedData.fushi"
            :key="index"
            @click="delFeedData(item, index)"
            class="list-names"
          >
            <span>
              {{ item.name }}
            </span>
            <div>
              <!-- <van-icon name="cross" /> -->
              <div class="close_icon_o"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="zhanwei" v-if="feedValue=='辅食'"></div>

    <!-- 配方奶粉、瓶装母乳选择值 -->
    <div
      v-show="feedValue == '配方奶粉' || feedValue == '瓶装母乳'"
      class="SelectPick"
    >
      <van-picker
        show-toolbar
        :columns="milkMl"
        confirm-button-text=" "
        cancel-button-text=" "
        visible-item-count="7"
        :default-index="milkMlColumnsIndex"
        item-height="25"
        @change="onChangeMilkMl($event)"
      />
      <div class="select-des" :class="!isAgent.isios?'select-des2':''">喂养量 <span>{{bottleWeight}}</span>ml</div>
    </div>

    <!-- 哺乳时长 -->
    <div v-show="feedValue == '母乳亲喂'">
      <div class="list-bt">
        <div>
          <h4>左侧哺乳时长</h4>
          <div>
            <van-stepper
              v-model="feedData.leftLactationTime"
              theme="round"
              min="0"
              :max="feedData.leftLactationTimeMax"
              disable-input
              @plus="plusLeftStepper"
              @minus="minusLeftStepper"
            />
            <span>分钟</span>
          </div>
        </div>
        <div>
          <h4>右侧哺乳时长</h4>
          <div>
            <van-stepper
              v-model="feedData.rightLactationTime"
              theme="round"
              min="0"
              :max="feedData.rightLactationTimeMax"
              disable-input
              @plus="plusLeftStepper"
              @minus="minusLeftStepper"
            />
            <span>分钟</span>
          </div>
        </div>
      </div>
      <div class="list-bt-tip">
        温馨提示：每十分钟建议更换一侧，更推荐瓶装方式喂养～
      </div>
    </div>
    <!-- 辅食 -->
    <div class="food" v-show="feedValue == '辅食'">
      <div class="food-list mt4" v-if="myFoodHistory.length > 0">
        <div>
          <h3>我的辅食</h3>
          <div class="food-edit" @click="editFood">
            {{ isEditClass ? '完成' : '编辑' }}
          </div>
        </div>
        <div class="food-list-item">
          <span
            v-for="(item, index) in myFoodHistoryData"
            :key="index"
            :class="item.isAct ? 'isAct' : ''"
            @click="delMyFood(index, item.name)"
          >
            {{ item.name }}
            <i v-if="isEditClass"><!-- <van-icon name="cross"/> --><div class="close_icon_o"></div></i>
          </span>
        </div>
      </div>
      <div class="food-list" v-for="(item, index) in foodList" :key="index">
        <div>
          <h3>{{ item.name }}</h3>
          <div
            class="food-edit"
            @click="editFood"
            v-if="myFoodHistory.length === 0 && index === 0"
          >
            {{ isEditClass ? '完成' : '编辑' }}
          </div>
        </div>
        <div>
          <span
            v-for="(itemChild, index1) in item.children"
            :key="index1"
            :class="itemChild.isAct ? 'isAct' : ''"
            @click="
              delFood(index, index1, itemChild.supplementName, itemChild.id)
            "
            v-show="!itemChild.isDel"
          >
            {{ itemChild.supplementName }}
            <i v-if="isEditClass"><!-- <van-icon name="cross"/> --><div class="close_icon_o"></div></i>
          </span>
          <span
            v-show="!isEditClass"
            class="food-list-add"
            @click="isFoodPopup(item.type, item.name, index)"
            >+</span
          >
        </div>
      </div>
    </div>
    <div  v-if="feedValue=='辅食'" class="zhanwei1"></div>
    <!-- 底部按钮 -->
    <div class="saveBtn" v-if="!isEditClass" :class="feedValue=='辅食'?'saveBtn_fushi':''">
      <button type="button" class="del" @click="delList" v-if="$route.query.id">
        删除
      </button>
      <button type="button" @click="saveSwitch&&savePage()" class="save">
        保存
      </button>
    </div>
    <!-- 选择年月 -->
    <van-popup v-model="datePopup" position="bottom" class="yearMonth">
      <van-datetime-picker
        v-model="feedData.currentDate"
        type="date"
        title="选择年月日"
        confirm-button-text=" "
        cancel-button-text=" "
        :max-date="maxDate"
      />

      <div class="milk-button">
        <div class="annul" @click="datePopup = false"></div>
        <div class="validation" @click="onFeedDate">确认</div>
      </div>
    </van-popup>

    <!-- 选择分秒 -->
    <van-popup v-model="hourPopup" position="bottom" class="minuteSecond">
      <van-datetime-picker
        v-model="feedData.currentTime"
        type="time"
        title="选择时分"
        confirm-button-text=" "
        cancel-button-text=" "
      />
      <div class="milk-button">
        <div class="annul" @click="hourPopup = false"></div>
        <div class="validation" @click="onFeedHours">确认</div>
      </div>
    </van-popup>

    <!-- 喂养方式 -->
    <van-popup v-model="feedPopup" position="bottom" class="feedPopup">
      <van-picker
        show-toolbar
        :default-index="feedTypeColumnsIndex"
        :columns="feedType"
        @change="feedTypeChange($event)"
        confirm-button-text=" "
        cancel-button-text=" "
      />

      <div class="milk-button">
        <div class="annul" @click="feedPopup = false"></div>
        <div class="validation" @click="onFeedType">确认</div>
      </div>
    </van-popup>

    <!-- 辅食喂养量 -->
    <van-popup v-model="feedWeightPopup" position="bottom" class="feedAmount">
      <van-picker
        show-toolbar
        :default-index="feedWeightColumnsIndex"
        :columns="feedWeight"
        :swipe-duration="10"
        @change="feedWeightChange($event)"
        confirm-button-text=" "
        cancel-button-text=" "
      />
      <div class="milk-button">
        <div class="annul" @click="feedWeightPopup = false"></div>
        <div class="validation" @click="onFeedWeight">确认</div>
      </div>
    </van-popup>

    <!-- 添加辅食名称 -->
    <van-popup v-model="addFoodValue" class="addFood">
      <div class="addFood_box">
        <div>
          <span>辅食名称</span>
          <input
            type="text"
            v-model="addFood.name"
            placeholder="最多输入6个字符"
            maxlength="6"
          />
        </div>
        <div>
          <span>当前分类</span>
          <input
            type="text"
            v-model="addFood.type.title"
            readonly
            @click="addFoodTypePopup = true"
          />
          <i class="arrow_down"></i>
        </div>
      </div>
      <div class="addFood_btn">
        <span @click="addFoodValue = false">取消</span>
        <span @click="saveFood">保存</span>
      </div>
    </van-popup>

    <!-- 辅食分类弹框 -->
    <van-popup v-model="addFoodTypePopup" position="bottom" class="feedClass">
      <van-picker
        show-toolbar
        :columns="foodKind"
        @change="foodKindChange($event)"
        :default-index="foodKindIndex"
        confirm-button-text=" "
        cancel-button-text=" "
      />

      <div class="milk-button">
        <div class="annul" @click="addFoodTypePopup = false"></div>
        <div class="validation" @click="onAddFoodType">确认</div>
      </div>
    </van-popup>

    <!-- 返回按钮 -->
    <goBack @goBack="goBack"></goBack>
    <!-- 加载中 -->
    <!-- <load-mask v-show="loadMaskShow"></load-mask> -->
  </div>
</template>

<script>
import { shareHome } from '@/minxs/shareHome.js'; //分享
import { Debounce } from '@/assets/js/common.js'; //防抖
import { Exposurer_feedToolsAllpageView } from '@/assets/js/Exposure'; //埋点
import FeedAPI from '@/utils/axiosApi/feedApi';
import { uniqueArr, TestUserAgent } from '@/assets/js/common.js';
import goBack from '@/components/common/goBack.vue';
import loadMask from '@/components/common/loading.vue'; //加载弹窗
import { capacityColumns, feedWeightColumns} from '@/utils/mockData/referMilkData';

export default {
  name: '',
  mixins: [shareHome],
  components: {
    goBack,
    loadMask
  },
  data() {
    return {
      datePopup: false, //年月日选择框
      maxDate: new Date(), //年月日选择框最大时间
      hourPopup: false, //小时分钟选择框
      addFoodValue: false, //辅食名称选择框

      feedData: {
        currentDate: new Date(), //喂养日期
        currentDateTemp: new Date(), //选择框喂养日期
        currentTime: '', //喂养时间
        currentTimeTemp: '', //选择框喂养时间
        fushi: [], //辅食列表
        fushiParam: [], //选择的辅食列表
        leftLactationTime: 5, //母乳亲喂左侧时间
        rightLactationTime: 5, //母乳亲喂右侧时间
        leftLactationTimeMax: 30, //母乳亲喂左侧最大时间
        rightLactationTimeMax: 30 //母乳亲喂右侧最大时间
      }, // 接口发送的数据

      feedValue: '配方奶粉', //喂养方式
      feedValueTemp: null, //选择框喂养方式

      bottleWeight: '200ml', //配方奶粉 和 瓶装母乳喂养量
      breastWeight: '150', //母乳喂养量
      milkMlColumnsIndex: 0, //配方奶粉、瓶装母乳默认下标
      milkMl: capacityColumns, //配方奶粉、瓶装母乳选择框列表值

      feedPopup: false, //喂养方式选择框
      feedTypeColumnsIndex: 0, //喂养方式选择框下标
      feedType: ['配方奶粉', '瓶装母乳', '母乳亲喂', '辅食'], //喂养方式选择框列表值
      // 辅食相关数据
      feedWeightPopup: false, //辅食喂养量选择框
      fushiWeight: '150', //辅食默认喂养量
      feedWeightColumnsIndex: 0, //辅食默认选择下标
      fushiWeightTemp: null, //选择框辅食喂养量
      feedWeight: feedWeightColumns, //辅食喂养量选择框列表值
      isEditClass: false, //辅食编辑
      isEditAct: false, //辅食是否选中编辑
      foodList: [
        {
          type: 1,
          name: '米面粉类',

          children: [
            {
              supplementName: '米粉',
              isDel: false,
              isAct: false,
              id: 1
            },
            {
              supplementName: '小面条',
              isDel: false,
              isAct: false,
              id: 2
            },
            {
              supplementName: '米汤',
              isDel: false,
              isAct: false,
              id: 3
            },
            {
              supplementName: '小米山药粥',
              isDel: false,
              isAct: false,
              id: 4
            },
            {
              supplementName: '八宝粥',
              isDel: false,
              isAct: false,
              id: 5
            },
            {
              supplementName: '虾蓉小混沌',
              isDel: false,
              isAct: false,
              id: 6
            },
            {
              supplementName: '小水饺',
              isDel: false,
              isAct: false,
              id: 7
            },
            {
              supplementName: '肉末粥',
              isDel: false,
              isAct: false,
              id: 8
            },
            {
              supplementName: '蛤蜊虾仁粥',
              isDel: false,
              isAct: false,
              id: 9
            },
            {
              supplementName: '鲜玉米糊',
              isDel: false,
              isAct: false,
              id: 10
            },
            {
              supplementName: '菠菜蛋黄粥',
              isDel: false,
              isAct: false,
              id: 11
            },
            {
              supplementName: '奶油通心粉',
              isDel: false,
              isAct: false,
              id: 12
            },
            {
              supplementName: '芝麻粥',
              isDel: false,
              isAct: false,
              id: 13
            },
            {
              supplementName: '番茄鸡蛋面',
              isDel: false,
              isAct: false,
              id: 14
            }
          ]
        },
        {
          type: 2,
          name: '水果类',

          children: [
            {
              supplementName: '苹果胡萝卜汁',
              isDel: false,
              isAct: false,
              id: 1
            },
            {
              supplementName: '香蕉粥',
              isDel: false,
              isAct: false,
              id: 2
            },
            {
              supplementName: '梨酱',
              isDel: false,
              isAct: false,
              id: 3
            },
            {
              supplementName: '苹果酪',
              isDel: false,
              isAct: false,
              id: 4
            },
            {
              supplementName: '什锦沙拉',
              isDel: false,
              isAct: false,
              id: 5
            },
            {
              supplementName: '苹果燕麦糊',
              isDel: false,
              isAct: false,
              id: 6
            },
            {
              supplementName: '椰丝小奶方',
              isDel: false,
              isAct: false,
              id: 7
            },
            {
              supplementName: '鲜橙汁',
              isDel: false,
              isAct: false,
              id: 8
            },
            {
              supplementName: '山楂酱',
              isDel: false,
              isAct: false,
              id: 9
            },
            {
              supplementName: '胡萝卜山楂汁',
              isDel: false,
              isAct: false,
              id: 10
            },
            {
              supplementName: '西红柿苹果汁',
              isDel: false,
              isAct: false,
              id: 11
            },
            {
              supplementName: '白萝卜生梨汁',
              isDel: false,
              isAct: false,
              id: 12
            },
            {
              supplementName: '蒸苹果',
              isDel: false,
              isAct: false,
              id: 13
            },
            {
              supplementName: '西瓜糊',
              isDel: false,
              isAct: false,
              id: 14
            }
          ]
        },
        {
          type: 3,
          name: '蔬菜类',

          children: [
            {
              supplementName: '青菜泥',
              isDel: false,
              isAct: false,
              id: 1
            },
            {
              supplementName: '猪骨胡萝卜泥',
              isDel: false,
              isAct: false,
              id: 2
            },
            {
              supplementName: '鸡汁土豆泥',
              isDel: false,
              isAct: false,
              id: 3
            },
            {
              supplementName: '丝瓜木耳',
              isDel: false,
              isAct: false,
              id: 4
            },
            {
              supplementName: '牛奶红薯泥',
              isDel: false,
              isAct: false,
              id: 5
            },
            {
              supplementName: '肉末茄泥',
              isDel: false,
              isAct: false,
              id: 6
            },
            {
              supplementName: '南瓜汁',
              isDel: false,
              isAct: false,
              id: 7
            },
            {
              supplementName: '菜泥面糊',
              isDel: false,
              isAct: false,
              id: 8
            },
            {
              supplementName: '香煎土豆片',
              isDel: false,
              isAct: false,
              id: 9
            },
            {
              supplementName: '木瓜炖银耳',
              isDel: false,
              isAct: false,
              id: 10
            },
            {
              supplementName: '牛奶西米露',
              isDel: false,
              isAct: false,
              id: 11
            },
            {
              supplementName: '黄瓜蜜条',
              isDel: false,
              isAct: false,
              id: 12
            },
            {
              supplementName: '丝瓜木耳',
              isDel: false,
              isAct: false,
              id: 13
            },
            {
              supplementName: '琥珀桃仁',
              isDel: false,
              isAct: false,
              id: 14
            }
          ]
        },
        {
          type: 4,
          name: '肉蛋奶类',

          children: [
            {
              supplementName: '鸡肝',
              isDel: false,
              isAct: false,
              id: 1
            },
            {
              supplementName: '煮鸡蛋',
              isDel: false,
              isAct: false,
              id: 2
            },
            {
              supplementName: '鸡蛋羹',
              isDel: false,
              isAct: false,
              id: 3
            },
            {
              supplementName: '三鲜蛋羹',
              isDel: false,
              isAct: false,
              id: 4
            },
            {
              supplementName: '番茄牛肉',
              isDel: false,
              isAct: false,
              id: 5
            },
            {
              supplementName: '四色炒蛋',
              isDel: false,
              isAct: false,
              id: 6
            },
            {
              supplementName: '蛋黄粉',
              isDel: false,
              isAct: false,
              id: 7
            },
            {
              supplementName: '鲜虾肉泥',
              isDel: false,
              isAct: false,
              id: 8
            },
            {
              supplementName: '肝肉泥',
              isDel: false,
              isAct: false,
              id: 9
            },
            {
              supplementName: '牛肉泥',
              isDel: false,
              isAct: false,
              id: 10
            },
            {
              supplementName: '菠菜牛肉粥',
              isDel: false,
              isAct: false,
              id: 11
            },
            {
              supplementName: '贝母粥',
              isDel: false,
              isAct: false,
              id: 12
            },
            {
              supplementName: '清蒸鳕鱼',
              isDel: false,
              isAct: false,
              id: 13
            },
            {
              supplementName: '肉糜鸡蛋',
              isDel: false,
              isAct: false,
              id: 14
            }
          ]
        },
        {
          type: 5,
          name: '复合辅食',

          children: [
            {
              supplementName: '冬瓜肉末面条',
              isDel: false,
              isAct: false,
              id: 1
            },
            {
              supplementName: '豆腐鲫鱼汤',
              isDel: false,
              isAct: false,
              id: 2
            },
            {
              supplementName: '虾仁豆腐粥',
              isDel: false,
              isAct: false,
              id: 3
            },
            {
              supplementName: '鱼泥青菜粥',
              isDel: false,
              isAct: false,
              id: 4
            }
          ]
        }
      ], //辅食列表值
      foodKindIndex: 0, //辅食分类选择框默认下标
      foodKind: ['米面粉类', '水果类', '蔬菜类', '肉蛋奶类', '复合辅食'], //辅食分类选择框列表值
      addFood: {
        name: '', //添加辅食名称
        type: {
          title: '米面粉类', //当前选择的分类
          id: '1' //当前选择分类的id
        },
        typeTemp: {} //切换选择框数据
      }, //添加辅食的数据

      myFoodHistory: [], //我的辅食
      myFoodHistoryData: [], //我的辅食数据

      delBasicData: [], //删除自定义辅食列表
      delUserData: [], //删除用户添加的辅食列表

      addFoodTypePopup: false, //添加辅食分类弹框
      UserInfo: null, //用户信息
      point: {
        Insert_Feedingway_Before: '',
        Feeding_way_Home: this.$route.query.feedType ? '母乳喂养' : '奶粉喂养',
        Baby_Month: this.$route.query.monthAge,
        Visit_Channel: '',
        Insert_Type: ''
      }, //埋点数据
      loadMaskShow: false, //loading动画
      isAgent:{},
      saveSwitch: true// 加个开关
    };
  },
  beforeDestroy(){
    this.saveSwitch = false
  },
  async created() {
    this.isAgent = TestUserAgent()
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.initHistory(); //初始化我的辅食

    const id = this.$route.query.id;
    const source = this.$route.query.source;
    let title,Insert_Type,Visit_Channel;
    if (id) {
      document.title = '日记详情';
      title = '日记详情页';
      Insert_Type = '修改';
      await this.initPageInfo(); //回显页面信息
    } else {
      title = '添加喂养日记';
      document.title = '添加喂养日记';
      Insert_Type = '添加';
      await this.initShowMl(); //回显默认ml
      const date = this.$route.query.date; //从喂养日历带来时间
      if (date) {
        this.feedData.currentDate = new Date(date);
        this.feedData.currentDateTemp = date;
      }
      this.feedData.currentTime = this.formatHours(new Date().getTime());
      this.feedData.currentTimeTemp = this.formatHours(new Date().getTime());
    }

    if(source == 'feedIndex'){
      Visit_Channel = '首页添加记录入口';
    } else if(source == 'feedNode'){
      Visit_Channel = '喂养日记页面添加入口';
    } else{
      Visit_Channel = '喂养明细进入';
    }




     this.point.Visit_Channel =  Visit_Channel;
     this.point.Insert_Type =  Insert_Type;

    const data = JSON.parse(localStorage.getItem('toolFeedPoint'));



    sensors.track('Tool_Feedinglog_Insert_feeding_dairy_Click', {
      Feeding_way_Home: this.point.Feeding_way_Home,
      Baby_Month:  this.point.Baby_Month,
      Visit_Channel: Visit_Channel,
      Insert_Type: Insert_Type
    });

    //浏览页面埋点
    setTimeout(() => {
      Exposurer_feedToolsAllpageView.observe('.feed-box', false, {
        System_FeedingCapacity: data.System_FeedingCapacity || '',
        Baby_Month: this.point.Baby_Month,
        Feeding_way_Home: data.Feeding_way_Home,
        page_name: title
      });
    }, 2000);

    // const type = this.$route.query.type;
    // let val = '配方奶粉';

    // if (type == 1) {
    //   val = '配方奶粉';
    // } else if (type == 2) {
    //   val = '瓶装母乳';
    // } else if (type == 3) {
    //   val = '母乳亲喂';
    // } else if (type == 4) {
    //   val = '辅食';
    // }

    this.getFoodList(); //初始化辅食数据

  },
  methods: {
    uniqueArr,

    //修改回显页面信息
    initPageInfo() {
      let list = JSON.parse(sessionStorage.getItem('toolFeedDetail'));
      if (list) {
        this.feedData.currentDate = new Date(list.feedDate);
        this.feedData.currentTime = list.feedTime;
        this.feedData.currentDateTemp = list.feedDate;
        this.feedData.currentTimeTemp = list.feedTime;

        const type = this.$route.query.type;
        const obj = {1:'配方奶粉',2:'瓶装母乳',3:'母乳亲喂',4:'辅食'}

        if (type == 1 || type == 2) { //配方奶粉、瓶装母乳
          this.milkMlColumnsIndex = this.milkMl.indexOf(
            list.feedQuantity + ''
          );
          this.bottleWeight = list.feedQuantity
        } else if (type == 3) { //母乳亲喂
          this.breastWeight = list.feedQuantity;
          this.feedData.leftLactationTime = list.leftLactationTime;
          this.feedData.rightLactationTime = list.rightLactationTime;
        } else if (type == 4) { //辅食
          this.feedWeightColumnsIndex = this.feedWeight.indexOf(
             list.feedQuantity+ ''
          );
          this.fushiWeight = list.feedQuantity;

          const fushiName = list.supplementNames;
          const data = this.myFoodHistoryData;
          let res = [];
          let res1 = [];

          // 回显添加的辅食、让下标和我的辅食一致
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < fushiName.length; j++) {
              if (data[i].name == fushiName[j]) {
                res.push({
                  name: fushiName[j],
                  selfIndex: i
                });
                res1.push(fushiName[j]);
              }
            }
          }

          this.feedData.fushiParam = res1;
          this.feedData.fushi = res;
        }

        this.feedValue = obj[type]; //喂养方式value
        this.feedTypeColumnsIndex = type - 1; //喂养方式下标

        this.point.Insert_Feedingway_Before =  obj[type];

      }



      sensors.track('Tool_Feedingdairy_Modify', {
        Feeding_way_Home: this.point.Feeding_way_Home,
        Baby_Month: this.point.Baby_Month
      });
    },
    //初始化ml
    initShowMl() {
      const month = parseInt(this.$route.query.monthAge);
      const type = this.$route.query.type;
      // 1:配方奶粉 2:瓶装母乳 3:母乳亲喂 4:辅食
      if (type == 1 || type == 2) {
        // this.milkMl.forEach((ele,index,arr) => {
        //     if (arr[index] == month) {
        //         this.milkMlColumnsIndex = index
        //     }
        // });
        switch (month) {
          case 0:
            this.milkMlColumnsIndex = 11;
            break;
          case 1:
            this.milkMlColumnsIndex = 15;
            break;
          case 2:
            this.milkMlColumnsIndex = 23;
            break;
          case 3:
            this.milkMlColumnsIndex = 27;
            break;
          case 4:
            this.milkMlColumnsIndex = 31;
            break;
          case 5:
            this.milkMlColumnsIndex = 37;
            break;
          case 6:
            this.milkMlColumnsIndex = 38;
            break;
          case 7:
            this.milkMlColumnsIndex = 39;
            break;
          case 8:
            this.milkMlColumnsIndex = 40;
            break;
          case 9:
            this.milkMlColumnsIndex = 41;
            break;
          case 10:
            this.milkMlColumnsIndex = 42;
            break;
          case 11:
            this.milkMlColumnsIndex = 43;
            break;
          default:
            this.milkMlColumnsIndex = 47;
        }

        this.bottleWeight = this.milkMl[this.milkMlColumnsIndex];
      }

      if (month < 5) {
        this.feedWeightColumnsIndex = 0;
      } else if (month == 5 || month == 6) {
        this.feedWeightColumnsIndex = 7;
      } else if (month == 7 || month == 8) {
        this.feedWeightColumnsIndex = 9;
      } else if (month == 9 || month == 10) {
        this.feedWeightColumnsIndex = 11;
      } else if (month == 11 || month == 12) {
        this.feedWeightColumnsIndex = 13;
      } else if (month == 13 || month == 14) {
        this.feedWeightColumnsIndex = 15;
      } else if (month == 15 || month == 16) {
        this.feedWeightColumnsIndex = 17;
      } else if (month == 17 || month == 18) {
        this.feedWeightColumnsIndex = 19;
      } else if (month == 19 || month == 20) {
        this.feedWeightColumnsIndex = 21;
      } else if (month == 21 || month == 22) {
        this.feedWeightColumnsIndex = 23;
      } else if (month == 23 || month == 24) {
        this.feedWeightColumnsIndex = 25;
      } else if (month == 25 || month == 26) {
        this.feedWeightColumnsIndex = 27;
      } else if (month == 27 || month == 28) {
        this.feedWeightColumnsIndex = 29;
      } else if (month == 29 || month == 30) {
        this.feedWeightColumnsIndex = 31;
      } else if (month == 31 || month == 32) {
        this.feedWeightColumnsIndex = 33;
      } else if (month == 33 || month == 34) {
        this.feedWeightColumnsIndex = 35;
      } else {
        this.feedWeightColumnsIndex = 39;
      }

      this.fushiWeight = this.feedWeight[this.feedWeightColumnsIndex];
    },
    //初始化辅食数据
    getFoodList() {
      FeedAPI.getfindSupplement(
        {
          crmId: this.UserInfo.crm_id,
          parity: this.$route.query.num || 1
        },
        (res) => {
          if (res.code == 200) {
            this.filterData(res.data);
          }
        }
      );
    },
    // 过滤辅食数据
    filterData(data) {
      let ele;
      let list;

      for (let index = 0; index < data.length; index++) {
        ele = parseInt(data[index].supplementType) - 1;

        list = this.foodList[ele].children;

        // 删除基础食物
        for (let j = 0; j < list.length; j++) {
          if (list[j].id === data[index].basics) {
            list.splice(j, 1);
          }
        }
        this.foodList[ele].children = list;

        //添加自定义食物
        this.foodList[ele].children.push(data[index]);
      }
    },

    // 切换喂养方式
    feedTypeChange(e) {
      const val = e.getValues(e.$el)[0];
      if (val == '母乳亲喂') {
        const maxNum = parseInt(
          this.feedData.leftLactationTime + this.feedData.rightLactationTime
        );

        this.breastWeight = maxNum * 15; //母乳喂养量
      }
      this.feedValueTemp = e.getValues(e.$el)[0];
    },
    // 确定喂养方式
    onFeedType() {
      if (this.feedValueTemp) {
        this.feedValue = this.feedValueTemp;
      }
      this.feedPopup = false;
    },

    // 切换喂养量
    onChangeMilkMl(e) {
      this.bottleWeight = e.getValues(e.$el)[0];
    },

    //母乳亲喂喂养量改变
    changeInput(e) {
      this.breastWeight = e.target.value.replace(/[^\d]/g, '');;
      // let val = e.target.value.replace(/[^\d]/g, '');
      // if(val > 450){
      //   this.breastWeight = 450;
      // }else{
      //   this.breastWeight = e.target.value.replace(/[^\d]/g, '');;
      // }
    },

    //增加母乳亲喂左侧时间
    plusLeftStepper() {
      const maxNum = parseInt(
        this.feedData.leftLactationTime + this.feedData.rightLactationTime
      );
      if (maxNum == 30) {
        this.$toast({
          duration: 1000,
          message: '最多添加30分钟哦！'
        });
        this.feedData.rightLactationTimeMax = this.feedData.rightLactationTime;
        this.feedData.leftLactationTimeMax = this.feedData.leftLactationTime;
      } else {
        this.breastWeight = maxNum * 15 + 15;
      }
    },
    //减少母乳亲喂左侧时间
    minusLeftStepper() {
      const maxNum = parseInt(
        this.feedData.leftLactationTime + this.feedData.rightLactationTime
      );
      if (maxNum == 30) {
        this.feedData.rightLactationTimeMax = 30;
        this.feedData.leftLactationTimeMax = 30;
      }

      this.breastWeight = maxNum * 15 - 15;
    },

    //删除当前信息
    delList() {
      this.$dialog
        .confirm({
          message: '确认要删除吗？',
          confirmButtonText: '确定'
        })
        .then(() => {
          this.loadMaskShow = true;
          FeedAPI.deleteFeedDiary(
            {
              id: this.$route.query.id
            },
            (res) => {
              if (res.code == 200) {
                this.$toast({
                  duration: 1000,
                  message: '删除成功！'
                });

                sensors.track('Tool_Feedingdairy_Delete', {
                  Feeding_way_Home: this.point.Feeding_way_Home,
                  Baby_Month: this.point.Baby_Month,
                  Delete_Feeding_way_Before: this.point.Insert_Feedingway_Before
                });

                setTimeout(() => {
                  this.goBack();
                }, 1000);
              }
              this.loadMaskShow = false;
            },() => {
              this.loadMaskShow = false;
            }
          );

        })
        .catch(() => {});
    },

    // 保存添加信息
    savePage: Debounce(function() {
      if (!this.saveSwitch) return
        this.saveSwitch = false
        this.loadMaskShow = true;
        this.feedData.currentDate = this.formatDate(this.feedData.currentDate);

        let val = this.feedValue;
        let type = 1;
        let mlvolume;

        let leftLactationTime = 0;
        let rightLactationTime = 0;

        if (val == '配方奶粉') {
          type = 1;
          mlvolume = this.bottleWeight;
        } else if (val == '瓶装母乳') {
          type = 2;
          mlvolume = this.bottleWeight;
        } else if (val == '母乳亲喂') {
          type = 3;
          const val = this.breastWeight;
          // const val = parseInt(this.breastWeight);
          if (val == '' || val == 0) {
            this.$toast({
              duration: 1000,
              message: '喂养量不能为空哦！',
              context: this
            });
            this.loadMaskShow = false;
            return;
          } else if (val > 450) {
            this.$toast({
              duration: 1000,
              message: '最多喂养量为450ml哦！',
              context: this
            });
            this.loadMaskShow = false;
            return;
          }
          mlvolume = this.breastWeight;
          leftLactationTime = this.feedData.leftLactationTime;
          rightLactationTime = this.feedData.rightLactationTime;
        } else if (val == '辅食') {
          type = 4;
          mlvolume = this.fushiWeight;
          if (this.feedData.fushiParam.length == 0) {
            this.$toast({
              duration: 1000,
              message: '请添加辅食哦',
              context: this
            });
            this.loadMaskShow = false;
            return;
          }
          this.addHistory(); //添加我的辅食
        }

        const foodId = this.$route.query.id;

        FeedAPI.addFeedDiary(
          {},
          {
            id: foodId ? foodId : '',
            isDel: false,
            feedType: type,
            crmId: this.UserInfo.crm_id,
            feedQuantity: parseInt(mlvolume),
            feedDate: this.feedData.currentDate,
            feedTime: this.feedData.currentTime,
            leftLactationTime: leftLactationTime,
            rightLactationTime: rightLactationTime,
            supplementNames: this.feedData.fushiParam.toString(),
            parity: this.$route.query.num || 1
          },
          (res) => {
            if (res.code == 200) {
              this.loadMaskShow = false;
              if (res.message == '添加成功！') {
                if (foodId) {
                  sensors.track('Tool_Feedingdairy_Modify_Done', {
                    Feeding_way_Home: this.point.Feeding_way_Home,
                    Baby_Month: this.point.Baby_Month,
                    Insert_Feeding_way_Before: this.point.Insert_Feedingway_Before,
                    Insert_Feeding_way_After: this.feedValue
                  });
                  this.$toast({
                    duration: 1000,
                    message: '修改成功！'
                  });
                } else {
                  this.$toast({
                    duration: 1000,
                    message: '添加成功！'
                  });
                }
                sensors.track('Tool_Feedinglog_Insert_feeding_dairy_success_Click', {
                  Feeding_way_Home: this.point.Feeding_way_Home,
                  Baby_Month: this.point.Baby_Month,
                  Visit_Channel: this.point.Visit_Channel,
                  Insert_Type: this.point.Insert_Type,
                  Insert_Feeding_way: this.feedValue
                });
                setTimeout(() => {
                  this.$router.go(-1,()=>{
                    this.saveSwitch = true
                  });

                }, 200);
              } else {
                this.saveSwitch = true
                this.$toast({
                  duration: 1000,
                  message: res.message
                });
              }
            }
          },
          (res) => {
            this.saveSwitch = true
            this.loadMaskShow = false;
          }
        );
    }, 500),

    // 获取本地辅食记录
    initHistory() {
      let historyStr = '';
      if (
        localStorage.getItem('toolFeedHistory') &&
        localStorage.getItem('toolFeedHistory') !== ''
      ) {
        historyStr = historyStr + ',' + localStorage.getItem('toolFeedHistory');
        localStorage.removeItem('toolFeedHistory');
      }
      localStorage.setItem('toolFeedHistory', historyStr);
      historyStr.split(',').forEach((item) => {
        if (item == '') return;
        this.myFoodHistory.push(item);
        this.myFoodHistoryData.push({ name: item, isAct: false });
      });
    },
    // 添加本地辅食记录
    addHistory() {
      //往storage添加历史记录
      let historyStr = this.feedData.fushiParam.toString();
      historyStr.split(',').forEach((item) => {
        this.myFoodHistory.unshift(item);
      });

      this.myFoodHistory = this.uniqueArr(this.myFoodHistory);
      if (this.myFoodHistory.length > 10) {
        this.myFoodHistory = this.myFoodHistory.slice(0, 10);
      }
      localStorage.setItem('toolFeedHistory', this.myFoodHistory.join(','));
    },
    // 添加食物
    isFoodPopup(type, name, index) {
      const children = this.foodList[index].children;
      const temp = [];
      for (let i = 0; i < children.length; i++) {
        if (children[i].isDel == false) {
          temp.push(i);
        }
      }
      if (temp.length >= 14) {
        this.$toast({
          duration: 2000,
          message: '最多显示14种食物，请删除一种再添加哦！'
        });
      } else {
        this.addFoodValue = true;
        this.addFood.name = '';
        this.addFood.type = { title: name, id: type };
        this.foodKindIndex = index;
      }
    },
    // 保存辅食
    saveFood() {
      const index = parseInt(this.addFood.type.id) - 1;

      const children = this.foodList[index].children;
      const temp = [];
      for (let i = 0; i < children.length; i++) {
        if (children[i].isDel == false) {
          temp.push(i);
        }
      }
      if (temp.length >= 14) {
        this.$toast({
          duration: 2000,
          message: '该分类下已经有14种食物，请删除一种再添加哦！'
        });
      } else {
        if (this.addFood.name.trim() == '') {
          this.$toast({
            duration: 2000,
            message: '辅食名称不能为空哦！'
          });
        } else {
          FeedAPI.saveSupplement(
            {},
            [
              {
                basics: 0,
                crmId: this.UserInfo.crm_id,
                parity: this.$route.query.num || 1,
                isDel: false,
                supplementName: this.addFood.name,
                supplementType: this.addFood.type.id,
                supplementTypeName: this.addFood.type.title
              }
            ],
            (res) => {
              if (res.code == 200) {
                this.foodList[parseInt(this.addFood.type.id) - 1].children.push(
                  {
                    supplementName: res.data[0].supplementName,
                    isDel: false,
                    isAct: false,
                    id: res.data[0].id
                  }
                );


                sensors.track('Tool_Editfeeding_dairy_Success', {
                  Feeding_way_Home: this.point.Feeding_way_Home,
                  Baby_Month: this.point.Baby_Month,
                  Side_dish_Name: this.addFood.name,
                  Side_dish_Type: this.addFood.type.title
                });

                // this.addFood = { name: '', type: '', index: 0 };
                this.addFoodValue = false;
              }
            }
          );
        }
      }
    },
    // 编辑食物
    editFood() {


      // 点击完成请求删除接口
      if (this.isEditClass) {
        if (this.delBasicData.length > 0) {
          FeedAPI.saveSupplement({}, this.delBasicData, (res) => {
            if (res.code == 200) {
              this.delBasicData = [];
            }
          });
        }
        if (this.delUserData.length > 0) {
          FeedAPI.deleteSupplement({}, this.delUserData, (res) => {
            if (res.code == 200) {
              this.delUserData = [];
            }
          });
        }
      }else{
        sensors.track('Tool_Feedinglog_Editfeeding_dairy', {
          Feeding_way_Home: this.point.Feeding_way_Home,
          Baby_Month: this.point.Baby_Month
        });
      }

      this.isEditClass = !this.isEditClass;
    },
    // 删除食物
    delFood(index, index1, name, id) {
      if (this.isEditClass) {
        this.handleDelFood(index, index1, id);
        this.foodList[index].children.splice(index1, 1);
      } else {
        const val = this.foodList[index].children[index1].isAct;
        const name = this.foodList[index].children[index1].supplementName;
        if (!val) {
          //如果没有选中
          if (this.feedData.fushi.length >= 3) {
            this.$toast({
              duration: 2000,
              message: '宝宝一次不要吃太多种类辅食哦~',
              context: this
            });
            return;
          }

          var fushi = this.feedData.fushi;
          for (let index = 0; index < fushi.length; index++) {
            if (fushi[index].name == name) {
              this.$toast({
                duration: 2000,
                message: '不能添加相同的辅食哦~',
                context: this
              });
              return;
            }
          }

          this.feedData.fushi.push({
            parentIndex: index,
            selfIndex: index1,
            name: name
          });
          this.feedData.fushiParam.push(name);
        } else {
          var fushi = this.feedData.fushi;
          for (let index = 0; index < fushi.length; index++) {
            if (fushi[index].name == name) {
              this.feedData.fushi.splice(index, 1);
              this.feedData.fushiParam.splice(index, 1);
            }
          }
        }
        this.foodList[index].children[index1].isAct = !val;
      }
    },
    // 删除我的实物
    delMyFood(index, name) {
      if (this.isEditClass) {
        this.myFoodHistoryData.splice(index, 1);

        let toolFeedHistory = localStorage.getItem('toolFeedHistory');
        let arr = [];

        toolFeedHistory.split(',').forEach((item) => {
          arr.push(item);
        });

        for (let j = 0; j < arr.length; j++) {
          if (arr[j] == name) {
            arr.splice(j, 1);
          }
        }

        sensors.track('Tool_Feedingdairy_Delete_sidedish', {
          Feeding_way_Home: this.point.Feeding_way_Home,
          Baby_Month: this.point.Baby_Month,
          Side_dish_Name: name,
          Side_dish_Type: '我的辅食'
        });

        localStorage.setItem('toolFeedHistory', arr.join(','));
      } else {
        const val = this.myFoodHistoryData[index].isAct;
        if (!val) {
          if (this.feedData.fushi.length >= 3) {
            this.$toast({
              duration: 2000,
              message: '宝宝一次不要吃太多种类辅食哦~',
              context: this
            });
            return;
          }

          var fushi = this.feedData.fushi;
          for (let index = 0; index < fushi.length; index++) {
            if (fushi[index].name == name) {
              this.$toast({
                duration: 2000,
                message: '不能添加相同的辅食哦~',
                context: this
              });
              return;
            }
          }

          this.feedData.fushi.push({
            name: name,
            selfIndex: index
          });
          this.feedData.fushiParam.push(name);
        } else {
          var fushi = this.feedData.fushi;
          for (let j = 0; j < fushi.length; j++) {
            if (fushi[j].name == name) {
              this.feedData.fushi.splice(j, 1);
              this.feedData.fushiParam.splice(j, 1);
            }
          }
        }

        this.myFoodHistoryData[index].isAct = !this.myFoodHistoryData[index]
          .isAct;
      }
    },
    // 处理删除辅食数据
    handleDelFood(index, index1, id) {
      if (parseInt(id) < 100) {
        this.delBasicData.push({
          basics: this.foodList[index].children[index1].id,
          crmId: this.UserInfo.crm_id,
          parity: this.$route.query.num || 1,
          isDel: true,
          supplementName: this.foodList[index].children[index1].supplementName,
          supplementType: this.foodList[index].type,
          supplementTypeName: this.foodList[index].name
        });
      } else {
        this.delUserData.push({ id: id });
      }

      sensors.track('Tool_Feedingdairy_Delete_sidedish', {
        Feeding_way_Home: this.point.Feeding_way_Home,
        Baby_Month: this.point.Baby_Month,
        Side_dish_Name: this.foodList[index].children[index1].supplementName,
        Side_dish_Type: this.foodList[index].name
      });
    },
    // 删除辅食
    delFeedData(item, index) {
      this.feedData.fushi.splice(index, 1);
      this.feedData.fushiParam.splice(index, 1);

      try {
        //删除基础分类
        this.foodList[item.parentIndex].children[item.selfIndex].isAct = false;
      } catch (error) {
        // 删除我的辅食
        this.myFoodHistoryData[item.selfIndex].isAct = false;
      }
    },
    // 切换辅食喂养量
    feedWeightChange(e) {
      this.fushiWeightTemp = e.getValues(e.$el)[0];
    },
    // 确定辅食喂养量
    onFeedWeight() {
      if (this.fushiWeightTemp) {
        this.fushiWeight = this.fushiWeightTemp;
      }
      this.feedWeightPopup = false;
    },
    // 切换辅食分类
    foodKindChange(e) {
      var index = this.foodKind.indexOf(e.getValues(e.$el)[0]);
      this.addFood.typeTemp = { title: e.getValues(e.$el)[0], id: index + 1 };
    },
    // 确定切换辅食分类
    onAddFoodType() {
      this.addFood.type = this.addFood.typeTemp;
      this.addFoodTypePopup = false;
    },
    // 是否显示年月日弹框
    isDatePopup() {
      this.datePopup = !this.datePopup;
    },
    // 确定年月日
    onFeedDate() {
      this.feedData.currentDateTemp = this.feedData.currentDate;
      this.datePopup = false;
    },
    // 是否显示小时分钟弹框
    isHourPopup() {
      this.hourPopup = !this.hourPopup;
    },
    // 确定小时
    onFeedHours() {
      this.feedData.currentTimeTemp = this.feedData.currentTime;
      this.hourPopup = false;
    },
    //格式化时间为 年月日
    formatDate(date) {
      var date = new Date(date); //转换成Data();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    //格式化时间为 小时：分钟
    formatHours(date) {
      var date = new Date(date);
      var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var m =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      return h + ':' + m;
    },
    // 返回
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less">
// body {
  // background: #fff;
// }
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #d4a437;
}
</style>
<style lang="less" scoped>
.feed-box {
  background: #fff;
  min-height: 100%;
}
.loading_box {
  background: rgba(0, 0, 0, 0.6);
}
.list-r p{
  font-size: 12px;
  color: #CCCCCC;
}
.feedPopup ,.SelectPick{
  /deep/ .van-picker__toolbar {
    height: auto;
  }
}
.close_icon_o {
  width: 10px;
  height: 10px;
  background: url('../../../../assets/images/tools/feedRecord/close_icon_o.svg') no-repeat center center/16px 16px;
}
.yearMonth,.minuteSecond,.feedPopup,.feedAmount,.feedClass {
  /deep/ .van-picker-column__item--selected {
    font-size: 19px;
  }
}
/deep/ .van-picker-column{
   font-size: 14px;
}
/deep/ .van-picker__cancel {
  padding: 0 7px;
}
/deep/ .van-picker__toolbar {
  justify-content: flex-start;
}
// /deep/ .van-picker__title {
//   font-size: 14px;
// }
/deep/ .van-popup--bottom {
  border-radius: 8px 8px 0 0;
}
/deep/ .van-picker__frame {
  left: 0;
  right: 0;
}

.milk-button {
  // position: absolute;
  // bottom: 0;
  display: flex;
  justify-content: center;
  padding: 0 72px;
  margin-top: 20px;
  margin-bottom: 14px;
  > div {
    width: 110px;
    height: 40px;
    border-radius: 20px;
    background: pink;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
  }
  .annul {
    width: 20px;
    height: 20px;
    border-radius: unset;
    position: absolute;
    top: 12px;
    right: 20px;
    z-index: 2;
    color: #dfb162;
    background: url('../../../../assets/images/tools/feedRecord/close_icon.png') no-repeat top left/20px 20px;
    // display: none;
  }
  .validation {
    color: #fff;
    background: #FB6E7E;
  }
}
/deep/ .van-dialog__confirm {
  color: #d4a437;
}
/deep/ .van-stepper__minus,
/deep/ .van-stepper__plus {
  display: flex;
  width: 18px;
  height: 18px;
  background: #FB6E7E;
  color: #ffffff;
  border-radius: 50px;
  border: unset;
}
/deep/ .van-stepper__minus::after,
/deep/ .van-stepper__plus::after{
  width: 2px;
}
/deep/ .van-stepper__minus::before,
/deep/ .van-stepper__plus::before {
  height: 2px;
}

/deep/ .van-stepper__input {
  background-color: #FFF0F2;
  color: #333333;
  text-align: center;
  font-size: 15px;
  margin-left: -27px;
  width: 20px;
  font-weight: 500;
  margin-top: 4px;
}

/deep/ .van-list__loading {
  background: #ffffff;
}
.mt4{
  margin-top: 4px;
}
.food-list {
  padding: 0 19px;
  background: #fff;

  > div:first-child {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    h3 {
      font-size: 15px;
      font-weight: 500;
      color: #333333;
    }
    .food-edit {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
    }
  }
  > div:last-child,
  .food-list-item {
    margin-top: 2px;
    span {
      display: inline-block;
      background: #f2f2f2;
      border-radius: 7px;
      padding: 0px 18px;
      height: 29px;
      line-height: 29px;
      text-align: center;
      margin-right: 8px;
      margin-top: 6px;
      font-size: 12px;
      color: #333333;
      position: relative;
      > i {
        display: flex;
        justify-content: center;
        position: absolute;
        right: -3px;
        top: -4px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        // background: #999999;
        .van-icon-cross {
          color: #ffffff;
          transform: scale(0.5);
          font-size: 12px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -6px;
          margin-top: -6px;
        }
      }
    }
    span.food-list-add {
      padding: 0px 18px;
      font-size: 21px;
      color: #d4d4d4;
      height: 29px;
      line-height: 29px;
      top: 3px;
    }
    span.isAct {
      background: #FFF0F2;
      color: #FF7181;
    }
  }
}
.list-bt {
  margin: 71px 52px 22px;
  display: flex;
  justify-content: space-between;

  > div {
    h4 {
      font-size: 15px;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }
    > div {
      margin-top: 17px;
      width: 110px;
      height: 110px;
      border: 1px dashed #FF7181;
      border-radius: 50%;
      display: flex;
      align-items: center;
      position: relative;
      padding: 0 8px;
      box-sizing: border-box;
      background: #FFF0F2;
      > div {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        height: 21px;
      }
      span {
        position: absolute;
        height: 21px;
        top: 50%;
        left: 44%;
        font-size: 15px;
        margin-top: -10.5px;
        font-weight: 500;
      }
    }
  }
  >div:first-child {
    /deep/ .van-stepper__plus::before {
      width: 10px;
    }
  }

  /deep/ .van-stepper__minus::before {
    border-radius: 2px;
  }
  /deep/ .van-stepper__plus::before {
    border-radius: 2px;
    width: 10px;
  }
  /deep/ .van-stepper__plus::after {
    border-radius: 2px;
    height: 10px;
  }
}
.list-bt-tip {
  display: block;
  width: 330px;
  height: 22px;
  line-height: 24px;
  border-radius: 11px;
  background: #FFF9F9;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  color: #FF7181;
  white-space: nowrap;
}
.list-input {
  border: none;
  text-align: right;
}
.back {
  width: 10px;
  height: 20px;
  padding-top: 6px;
  margin-right: 13px;
  margin-bottom: 7px;
  position: absolute;
  .arrow-left {
    width: 26px;
    height: 26px;
    margin-left: 12px;
    background: url('../../../../assets/images/home/back.png') left top/ 26px 26px;
  }
  // .van-icon-arrow-left {
  //   margin-left: 8px;
  //   font-size: 20px;
  //   color: #1a1a1a;
  // }
}
.SelectPick {
  height: 360px;
  background: url('../../../../assets/images/tools/feedRecord/milk_bottle.png') no-repeat top center/140px 300px;
  position: relative;
  margin-top: 30px;
  .select-des {
    width: 90px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background: url('../../../../assets/images/tools/feedRecord/background_tip.png') no-repeat left top/90px 26px;
    color: #FF7181;
    position: absolute;
    // top: 50%;
    top: 148px;
    left: 25px;
    // transform: translateY(-13px);
    span {
      font-size: 18px;
      font-weight: 700;
    }
  }
  .select-des2{
    top: 160px
  }
  .van-picker {
    margin: 0 141px;
    background-color: unset;
  }
  /deep/ .van-picker__columns {
    margin-top: 81px;
  }
  /deep/ .van-picker-column__item {
    color: #FF7181;
  }
  /deep/ .van-picker__mask {
    background-image: linear-gradient(180deg,hsla(352, 100%, 97%, .9),hsla(352, 100%, 97%,.4)),linear-gradient(0deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.4));
  }
  /deep/ .van-picker__frame {
    width: 46px;
    left: 50%;
    margin-left: -24px;
  }
  /deep/ .van-hairline--top-bottom::after,
  /deep/ .van-hairline-unset--top-bottom::after {
    border: 1px solid #FFCED4;
    border-left: none;
    border-right: none;
  }
}
.list {
  padding: 0 14px;
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px solid #eee;
    > div {
      display: inline-block;
    }
    > div:first-child {
      font-size: 13px;
      color: #111111;
    }
    > div:last-child {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #FB6E7E;
      .van-icon-arrow {
        color: #DDDDDD;
        font-size: 15px;
        right: -2px;
      }
    }
  }
  > div:last-child {
    border-bottom: none;
  }
  .list-names {
    position: relative;
    margin-right: 8px;
    span {
      font-size: 12px;
      background: #FFF0F2;
      border-radius: 7px;
      padding: 6px 8px;
      color: #FF7181;
    }
    > div {
      position: absolute;
      right: -3px;
      top: -4px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      // background: #999999;
      display: flex;
      justify-content: center;
      .van-icon-cross {
        color: #ffffff;
        transform: scale(0.5);
        font-size: 0.32rem;
        top: -1px;
      }
    }
  }
}
.food {
  margin-top: 4px;
  padding-bottom: 30px;
  background: #ffffff;
}

.addFood {
  margin: 0 auto;
  padding-top: 25px;
  width: 293px;
  border-radius: 4px;
  .addFood_box {
    padding: 0 34px 7px;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 22px;
      position: relative;
      font-size: 14px;
      color: #333333;
      span {
        font-weight: 500;
      }
      input {
        width: 162px;
        height: 28px;
        line-height: 28px;
        background: #ffffff;
        border-radius: 7px;
        border: 1px solid #eeeeee;
        padding: 5px 10px;
        box-sizing: border-box;
        -webkit-appearance: none;
        color: #333333;
      }
    }

    .arrow_down {
      position: absolute;
      top: 50%;
      margin-top: -2px;
      right: 10px;
      width: 9px;
      height: 6px;
      // border-left: 4px solid transparent;
      // border-right: 4px solid transparent;
      // border-top: 4px solid #333333;
      background: url('../../../../assets/images/icon/tick​Arrow.png') no-repeat top left/9px 6px;
    }
  }
  .addFood_btn {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #EEEEEE;
    > span {
      padding: 14px 0px;
      flex: 1;
      color: #333333;
      font-size: 16px;
      text-align: center;
    }
    > span:last-child {
      border-left: 1px solid #EEEEEE;
      color: #FB6E7E;
    }
  }
}

.saveBtn {
  width: 100%;
  background: #ffffff;
  padding: 11px 0px;
  text-align: center;
  position: fixed;
  bottom: 0;
  box-shadow: 0 0 4px 0 #eeeeee;
  .del {
    width: 110px;
    height: 44px;
    line-height: 44px;
    border-radius: 24px;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    font-size: 18px;
    color: #999999;
    text-align: center;
    margin-right: 10px;
  }
  .save {
    width: 284px;
    height: 44px;
    line-height: 44px;
    background: #FB6E7E;
    // background: linear-gradient(270deg, #d4a437 0%, #e5bf5d 100%);
    border-radius: 30px;
    font-size: 18px;
    color: #ffffff;
    border: none;
  }
  >button:nth-child(2){
     width: 230px;
  }
}
.saveBtn_fushi {
  position: fixed;
  left: 0;
  bottom: 0;
  box-shadow: 0px 0px 8px -1px rgba(0, 0, 0, 0.2);
}

.zhanwei {
  background: #f2f2f2;
  height: 10px;
}
.zhanwei1{
  width: 100%;
  height: 58px;
}
@media screen and (min-height: 721px) {
  /deep/ .van-stepper__input{
    background-color: #FFF0F2;
    color: #333333;
    text-align: center;
    font-size: 15px;
    margin-left: -27px;
    width: 20px;
    font-weight: 500;
    margin-top: 0px;
  }
}
@media screen and (min-height: 722px) and (max-height:728px) {
  /deep/ .van-stepper__input{
    background-color: #FFF0F2;
    color: #333333;
    text-align: center;
    font-size: 15px;
    margin-left: -27px;
    width: 20px;
    font-weight: 500;
    margin-top: 4px;
  }
}
</style>
